import { useDashboard } from "../dashboards/DashboardContext";
import styles from "./Widget.module.css";

export default function PeriodPicker() {
    const { years, monthsByYear, year, month, setYear, setMonth } = useDashboard();

    const validYears = Array.isArray(years) && years.length > 0 ? years : [year];
    const validMonths = monthsByYear?.[year] ?? [String(month).padStart(2, "0")];
    return (
        <div className={styles.uPeriod} style={{ justifySelf: "end", display: "flex", gap: 6 }}>
            <select value={year ?? ""} onChange={e => setYear(Number(e.target.value))}>
                {validYears.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
            <select value={month ?? ""} onChange={e => setMonth(e.target.value)}>
                {validMonths.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
        </div>
    );
}
